export function handleApplicationFormSubmit() {
    const applicationForm = document.querySelector(".pul-application-form form");


    if (applicationForm) {
        const fileInput = applicationForm.querySelector("input[type='file']");
        const fileText = applicationForm.querySelector(".file .file-text");

        let fileValid = true;

        if (fileInput) {
            const FILESIZE_LIMIT = 20 * 1024 * 1024;
            const FILE_EXTENSIONS = ["png", "jpg", "jpeg", "pdf", "doc", "docx", "ppt", "pptx"];


            fileInput.addEventListener("change", () => {
                const fileSize = fileInput.files[0].size;
                const fileExtension = fileInput.files[0].name.split(".").pop().toLowerCase();
                const fileName = fileInput.files[0].name;

                fileInput.setAttribute("disabled", "");

                fileText.querySelector("span").textContent = fileName;

                const deleteFileBtn = document.createElement("button");
                deleteFileBtn.innerHTML = `
                    <svg width="30" height="30" viewBox="0 0 30 30" aria-hidden="true">
                        <use href="/ResourcePackages/pfeiferlangen/assets/img/_icn/icn-close.svg#icn" />
                    </svg>
                `;

                fileText.appendChild(deleteFileBtn);

                deleteFileBtn.addEventListener("click", () => {
                    fileInput.removeAttribute("disabled");
                    fileInput.value = "";
                    fileText.querySelector("span").textContent = fileText.querySelector("span").dataset.text;
                    deleteFileBtn.remove();

                    fileValid = true;
                    fileInput.closest(".pul-form-col").classList.remove("has-error");
                });

                if (fileSize > FILESIZE_LIMIT || !FILE_EXTENSIONS.includes(fileExtension)) {
                    fileValid = false;
                    fileInput.closest(".pul-form-col").classList.add("has-error");
                } else {
                    fileValid = true;
                    fileInput.closest(".pul-form-col").classList.remove("has-error");
                }
            });
        }

        applicationForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const requiredFields = applicationForm.querySelectorAll(".pul-form-col:not(.hidden) [required]");
            const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            const submitButton = applicationForm.querySelector("button[type='submit']");

            let formValid = true;

            for (const field of requiredFields) {
                field.closest(".pul-form-col").classList.remove("has-error");

                field.addEventListener("click", () => {
                    field.closest(".pul-form-col").classList.remove("has-error");
                    if (field.closest(".pul-checkbox__element")) field.closest(".pul-checkbox__element").classList.remove("has-error");
                });

                if (field.type === "text" && field.value.trim() === "") {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "textarea" && field.value.trim() === "") {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "email" && !emailRegex.test(field.value.trim())) {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "select-one" && field.value === "") {
                    formValid = false;
                    field.closest(".pul-form-col").classList.add("has-error");
                }

                if (field.type === "checkbox" && !field.checked) {
                    formValid = false;
                    field.closest(".pul-checkbox__element").classList.add("has-error");
                }
            }

            if (!formValid || !fileValid) {
                document.querySelector(".has-error").scrollIntoView({ behaviour: "smooth" });
                return;
            } else {
                submit(applicationForm, submitButton, fileText);
            }
        });
    }
}

async function submit(applicationForm, submitButton) {
    const API_URL = applicationForm.action;
    const initialText = submitButton.dataset.initialText;
    const waitingText = submitButton.dataset.waitingText;
    const successText = submitButton.dataset.successText;
    const errorRow = applicationForm.querySelector(".pul-form-row--errors");
    const file = applicationForm.querySelector("input[type='file']");

    const formData = new FormData(applicationForm);
    formData.append("File", file.files[0]);

    errorRow.style.display = "none";
    errorRow.querySelector(".pul-form-col").innerHTML = "";

    submitButton.classList.add("is-loading");
    submitButton.querySelector("span").textContent = waitingText;

    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: formData
        });

        const data = await response.json();

        if (data.status === "failed") {
            const error = document.createElement("span");
            error.classList.add("error-msg");
            error.textContent = data.message;
            submitButton.classList.remove("is-loading");
            submitButton.querySelector("span").textContent = initialText;

            errorRow.querySelector(".pul-form-col").appendChild(error);
            errorRow.style.display = "flex";
        } else {
            errorRow.style.display = "none";
            errorRow.querySelector(".pul-form-col").innerHTML = "";
            submitButton.querySelector("span").textContent = successText;
            submitButton.classList.remove("is-loading");
            submitButton.classList.add("is-success");

            // const timeout = setTimeout(() => {
            //     submitButton.classList.remove("is-success");
            //     submitButton.querySelector("span").textContent = initialText;
            //     applicationForm.reset();

            //     clearTimeout(timeout);
            // }, 3000);
        }
    } catch (error) {
        console.log("Error sending form data:", error);
    }
}